import * as validate from '../vendor/validate';

export default function fSelect() {
    const timeList = document.querySelector('.js-fill-list');
    const timeInputWrappers = document.querySelectorAll('.js-time-input');

    timeInputWrappers.forEach((input) => {
        input.style.display = 'none';
    });

    function clearField(field) {
        const callbackTime = field;
        const callbackTimeValue = callbackTime.parentElement.querySelector('.js-select-value');
        callbackTime.value = '';
        callbackTimeValue.innerHTML = '';
    }

    function removeActiveState() {
        let select = document.querySelector(".js-select.is-active");

        if(select != null){
            select.classList.remove("is-active");
        }
    }

    document.addEventListener('click', function(event) {
        let select;

        if(event.target.matches('.js-select') || event.target.closest('.js-select')) {
            select = event.target.matches('.js-select') || event.target.closest('.js-select');

            if(select.matches('.is-active')) {
                removeActiveState();
            } else {
                removeActiveState();

                select.classList.add("is-active");
            }
        } else {
            if(!event.target.matches('.js-select.is-active') || event.target.closest('.js-select.is-active')) {
                removeActiveState();
            }
        }

        if(event.target.matches('.js-tag')) {
            let form = event.target.closest('form');
            let parent = event.target.closest('.js-select');
            let oSelectedValue = parent.querySelector('.js-select-value');
            let oHiddenInput = parent.querySelector('input[type="hidden"]');
            let oCallBackTime = form.querySelector('.js-callback-time');
            let timeInputWrapper = form.querySelector('.js-time-input');

            if (oSelectedValue) oSelectedValue.innerHTML = event.target.innerHTML;
            if (oHiddenInput) {
                const prevValue = oHiddenInput.value;
                oHiddenInput.value = event.target.innerHTML;

                // Validate the field
                let error = validate.hasError(oHiddenInput);

                // If there's an error, show it
                if (error) {
                    validate.showError(oHiddenInput, error);
                    return;
                }

                // Otherwise, remove any errors that exist
                validate.removeError(oHiddenInput);

                // And add success class to field
                oHiddenInput.classList.add('is-successful');

                if (oHiddenInput.className.includes('js-callback-day')) {
                    timeInputWrapper.style.display = 'block';

                    const weekDays = timeList.querySelectorAll('[data-normal]');
                    const friday = timeList.querySelector('[data-vr]');

                    if (oHiddenInput.value === 'Vrijdag') {

                        weekDays.forEach(element => {
                            element.style.display = 'none'
                        });

                        friday.style.display = 'block';

                        if (prevValue !== 'Vrijdag') {
                            clearField(oCallBackTime);
                        }
                    } else {
                        weekDays.forEach(element => {
                            element.style.display = 'block'
                        });

                        friday.style.display = 'none';

                        if (prevValue === 'Vrijdag') {
                            clearField(oCallBackTime);
                        }
                    }
                }
            }
        }
    });
}
